import { useController } from 'react-hook-form';
import { BasicSelect, BasicSelectProps, SelectValueType } from 'ui/selects';
import { FieldProps } from './types';

type BasicSelectFieldProps<TValue extends SelectValueType = string> = FieldProps<TValue> &
  Omit<BasicSelectProps<TValue>, 'defaultValues' | 'isError' | 'onSelect'>;

export const BasicSelectField = <TValue extends SelectValueType = string>({
  name,
  defaultValue,
  ...rest
}: BasicSelectFieldProps<TValue>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <BasicSelect
      {...rest}
      isError={!!error}
      defaultValues={[value]}
      onSelect={([selectedValue]) => onChange(selectedValue)}
    />
  );
};
